module.exports = __webpack_public_path__ + "img/rotate_arrow.6a3be70b.svg";